import { Component } from '@angular/core';
import { AuthService } from '../../../auth/services/auth.service';

@Component({
  selector: '[app-header]',
  templateUrl: './header.component.html',
})
export class HeaderComponent {
    constructor(
      private authService: AuthService
    ) {}

    logout() { 
      this.authService.logout();
     }
}